import type { ProductState } from '../../checkout/resourceSelection/redux/types';

// biome-ignore lint/style/noEnum: TODO: review this suppression
export enum PeriodUnit {
    YEAR = 'years',
    MONTH = 'months',
    DAY = 'days',
}

export interface Period {
    length: number;
    unit: PeriodUnit;
}

// biome-ignore lint/style/noEnum: TODO: review this suppression
export enum TermedLevelState {
    ACTIVE = 'ACTIVE',
    PENDING = 'PENDING',
}

// biome-ignore lint/style/noEnum: TODO: review this suppression
export enum HumanReadableTermedLevelState {
    active = 'active',
    active_terminating_soon = 'active_terminating_soon',
    pending = 'pending',
    active_without_activation = 'active_without_activation',
}

export interface TermedLevel {
    resourceId: string;
    resourceName?: string;
    resourceType: string;
    productId: string;
    productName: string;
    productLevelName: string;
    paid?: boolean;
    level: string;
    state: TermedLevelState;
    activationState: ProductState;
    periodLength: number;
    periodUnit: PeriodUnit;
    startsAt?: string;
    endsAt?: string;
    createdAt: string;
    isCancellable: boolean;
    tosVersion?: string;
    dosVersion?: string;
    renewsToLevel?: string;
    renewsToLevelName?: string;
    renewsToLevelVariantName?: string;
    renewsToLevelContractPeriodLength?: number;
    renewsToLevelContractPeriodUnit?: PeriodUnit;
    remainingDays?: number;
    criticalRemainingDays: boolean;
    contractState: HumanReadableTermedLevelState;
    hasInactiveActivationState: boolean;
    missingRequirements?: string[][];
    variantName: string;
}
